import { useRef, useEffect, useState } from 'react';
const debounceTime = 50;

export default function useShortcut({
  active = true,
  shortcut,
  handler,
  focusTagExclude,
}) {
  // If we pass an inline fucntion we would execute all this on every render.
  // Wrapping it on a useCallback is leaky and easy to forget, so...
  // Create a ref which keeps a reference to the current version of the callback.
  // This two lines will execute each render but the useEffect only once.
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  // Debounce shortcut press
  const debouncingRef = useRef(false);

  useEffect(() => {
    const shortcutKeys = shortcut.split('+');
    const shortcutObject = {
      ctrl: shortcutKeys.some((key) => key == 'Ctrl'),
      alt: shortcutKeys.some((key) => key == 'Alt'),
      shift: shortcutKeys.some((key) => key == 'Shift'),
      key: shortcutKeys.find((key) => !['Ctrl', 'Alt', 'Shift'].includes(key)),
    };

    function keyDownEventhandler(event) {
      if (
        active &&
        shortcutMatchesEvent(event, shortcutObject, focusTagExclude)
      ) {
        event.preventDefault();
        let debounceTimeout;
        if (debouncingRef.current) {
        } else {
          // Invoke whatever callback the ref is currently pointing to.
          debouncingRef.current = true;
          if (!debounceTimeout) {
            debounceTimeout = setTimeout(() => {
              debouncingRef.current = false;
            }, debounceTime);
          }
          try {
            handlerRef.current(event);
          } catch (e) {
            console.error(e, 'Error executing shortcut handler');
          }
        }
      }
    }

    window.addEventListener('keydown', keyDownEventhandler);

    return () => {
      window.removeEventListener('keydown', keyDownEventhandler);
    };
  }, []);
}

function shortcutMatchesEvent(
  event,
  { alt, ctrl, shift, key },
  focusTagExclude
) {
  const focusedElement = document.activeElement;
  return (
    event.altKey == alt &&
    (event.ctrlKey == ctrl || event.metaKey == ctrl) &&
    event.shiftKey == shift &&
    event.key &&
    event.key.toLowerCase() == key.toLowerCase() &&
    (focusTagExclude
      ? !focusTagExclude.includes(document.activeElement?.tagName)
      : true)
  );
}
